import theme from "@/theme";

export const styles = {
  appBar: {
    backgroundColor: theme.palette.custom.mainWhite,
    boxShadow: "none",
    padding: "0.5rem 0 0.5rem 1rem",
    borderBottom: "1px solid #F4F5F6",
  },
  appBarContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  tabsNavigation: {
    display: "flex",
    gap: "20px",
    marginLeft: "auto",
    height: "28px",
    minHeight: "0",
    "& .MuiTabs-scrollButtons": {
      display: "none",
    },
  },
  tabsNavigationIndicator: {
    backgroundColor: theme.palette.custom.mainBlue,
    height: "3px",
    borderRadius: "3px",
  },
  tabsNavigationTab: (props: { selected?: boolean }) => ({
    height: "28px",
    minHeight: "28px",
    padding: 0,
    mr: "20px",
    textTransform: "none",
    fontFamily: "Inter",
    fontSize: "15px",
    lineHeight: "24px",
    letterSpacing: 0,
    verticalAlign: "middle",
    fontWeight: props.selected ? 600 : 500,
    fontStyle: props.selected ? "Semi Bold" : "Medium",
    color: props.selected ? theme.palette.custom.mainBlue : "#4f5b67",
    "&:last-of-type": {
      mr: 0,
    },
  }),
};
